const OPEN = '(?:\\uE200|\\\\u[eE]200)';
const SEPARATOR = '(?:\\uE202|\\\\u[eE]202)';
const CLOSE = '(?:\\uE201|\\\\u[eE]201)';
const COMPLETE_MARKER = new RegExp(
  `${OPEN}(?:filecite|cite)(?:${SEPARATOR}[^\\uE200\\uE201\\r\\n]*?)?${CLOSE}`,
  'g',
);
const UNFINISHED_MARKER = new RegExp(`${OPEN}([^\\uE200\\uE201\\r\\n]*)(?=\\r?\\n|$)`, 'g');
const LEGACY_MARKER = /【\d+(?::\d+)?†[^】\r\n]+】/g;
const URL_OR_BARE_MARKER =
  /https?:\/\/[^\s<>()[\]`"]+|\b(?:file)?cite(?:turn\d+(?:view|search|news|fetch|image|file)\d+)+\b/g;
const HEADERS = [
  'cite\uE202',
  'filecite\uE202',
  String.raw`cite\ue202`,
  String.raw`filecite\ue202`,
];

/**
 * Hide provider citation references in display text that has no citation resolver.
 * Keeps ordinary source links and unknown markup intact. Accepts accumulated
 * streaming text, including an unfinished citation header or reference at its end.
 * This is a display projection, not a source resolver or a storage transformation.
 */
export function stripProviderCitationMarkers(text: string): string {
  return text
    .replace(COMPLETE_MARKER, '')
    .replace(UNFINISHED_MARKER, (marker, tail: string) => {
      const end = tail.search(/\s/);
      const reference = end < 0 ? tail : tail.slice(0, end);
      const header = reference.replace(/\\uE/g, '\\ue');
      return HEADERS.some((known) => known.startsWith(header) || header.startsWith(known))
        ? tail.slice(reference.length)
        : marker;
    })
    .replace(LEGACY_MARKER, '')
    .replace(URL_OR_BARE_MARKER, (match) => (/^https?:\/\//.test(match) ? match : ''));
}
